import { isCookieAuthEnabled } from './sessionAuth';

export interface PartnerPortalUser {
  id: string;
  email: string;
  role: 'partner';
  profile?: {
    firstName?: string;
    lastName?: string;
    phone?: string;
  };
}

export interface PartnerPortalPartner {
  id: string;
  name: string;
  organizationName?: string;
  organizationType?: string;
  apiKeyMasked?: string;
  scopes?: string[];
}

export const getPartnerPortalUser = (): PartnerPortalUser | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const raw = localStorage.getItem('partnerUser');
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as PartnerPortalUser;
  } catch {
    return null;
  }
};

export const getPartnerPortalPartner = (): PartnerPortalPartner | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const raw = localStorage.getItem('partnerApplication');
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as PartnerPortalPartner;
  } catch {
    return null;
  }
};

export const persistPartnerPortalSession = (
  user: PartnerPortalUser,
  partner: PartnerPortalPartner,
  token?: string | null,
): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const useCookie = isCookieAuthEnabled() || !token || token === 'cookie-session';
  if (!useCookie && token) {
    localStorage.setItem('token', token);
  }
  localStorage.setItem('partnerUser', JSON.stringify(user));
  localStorage.setItem('partnerApplication', JSON.stringify(partner));
};

export const clearPartnerPortalSession = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem('partnerUser');
  localStorage.removeItem('partnerApplication');
};

export const isPartnerPortalSession = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return Boolean(localStorage.getItem('partnerUser'));
};
